export const READING_CONFIRMATION_MS = 200;

const SCAN_SOUND_SOURCE =
    `${import.meta.env?.BASE_URL || './'}audio/bip.mp3`;

let scanAudio = null;
let scanAudioConstructor = null;
let scanAudioSource = null;

export function playScanSound({
    AudioConstructor = globalThis.Audio,
    source = SCAN_SOUND_SOURCE,
} = {}) {
    if (typeof AudioConstructor !== 'function') {
        return false;
    }

    try {
        if (
            !scanAudio
            || scanAudioConstructor !== AudioConstructor
            || scanAudioSource !== source
        ) {
            scanAudio = new AudioConstructor(source);
            scanAudioConstructor = AudioConstructor;
            scanAudioSource = source;

            try {
                scanAudio.preload = 'auto';
            } catch {
                // A preparação do áudio nunca interfere na leitura.
            }
        }

        try {
            scanAudio.pause?.();
        } catch {
            // Alguns navegadores recusam pause() antes do primeiro play().
        }

        try {
            scanAudio.currentTime = 0;
        } catch {
            // O play ainda pode funcionar quando o seek inicial é bloqueado.
        }

        const playback = scanAudio.play?.();

        if (typeof playback?.catch === 'function') {
            void playback.catch(() => {
                // Bloqueios de autoplay são silenciosos por definição.
            });
        }

        return true;
    } catch {
        return false;
    }
}

export function triggerReadingFeedback({
    root,
    navigatorLike = globalThis.navigator,
    audioOptions,
} = {}) {
    if (!root) {
        throw new TypeError('O HUD do scanner é obrigatório.');
    }

    // Toda leitura já validada confirma som, vibração e animação neste ponto.
    const soundStarted = playScanSound(audioOptions);

    let vibrated = false;

    if (typeof navigatorLike?.vibrate === 'function') {
        try {
            vibrated = navigatorLike.vibrate(60) !== false;
        } catch {
            vibrated = false;
        }
    }

    root.classList.remove('is-confirming');
    void root.offsetWidth;
    root.classList.add('is-confirming');

    return { vibrated, soundStarted };
}

export function clearReadingFeedback(root) {
    root?.classList?.remove('is-confirming');
}
